<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md7 sm9>
          <h3 class="text-center">Create Diagnostic Kit</h3>
          <v-card>
            <v-card-text>
              <form @submit.prevent="saveKit">
                <v-text-field label="Name" v-model="kit.name" required="required" maxLength="50" :counter="50" placeholder="Thermogun"></v-text-field>
                <v-text-field label="Description" v-model="kit.description" maxLength="250" :counter="250" placeholder="A contactless infrared thermometer"></v-text-field>
                <v-checkbox label="Required" v-model="kit.required" hint="Is it a requirement for professionals?"></v-checkbox>
                <v-btn small type="submit" color="primary" class="pull-right"><v-icon left>{{ icons.create }}</v-icon> Save</v-btn>
                <br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'DiagnosticKitCreate',
    layout,
    props: [],
    components: {},
    metaInfo () {
      return {
        title: 'Create Diagnostic Kit',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        kit: this.$inertia.form({
          name: '',
          description: '',
          model: '',
          required: false,
        })
      }
    },
    methods: {
      saveKit () {
        swal({
          title: 'Save Diagnostic Kit?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Save',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.kit.post('/diagnostic_kits', {
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
    },
  }
</script>
